import { Container, Modal } from "@mui/material";
import { useState } from "react";
import SummaryComponent from "./Summary";
import BagIcon from "assets/icons/BagIcon";
import DebtsIcon from "assets/icons/DebtsIcon";
import Blocks from "./Blocks";
import Portal from "components/Portal";
import useOpeningBalanceData from "./data";
import Table from "components/Table2";
import Button from "@mui/material/Button";
import ModalBox from "components/Shared/Modals/ModalBox";
import PieChartIcon from "assets/images/PieChartIcon.svg";
import BasicButton from "components/BasicInputs/BasicButton";
import PlusIcon from "assets/icons/PlusIcon";
import iconDelete from "../../assets/svg/icon-delete-bottom-table.svg";
import { useDispatch } from "react-redux";
import { setConfirm } from "store/actions/appAction";
import { apiDeleteOpennigBlance } from "api/openingBalanceApi";
import { BasicInput } from "components/Input/BasicInput";
import DateInput from "components/Input/DateInput";
import BasicDateInput from "components/BasicInputs/BasicDateInput";


export default function OpeningBalanceComponent() {
  const [active, setActive] = useState<OpeningBalanceItem["type"]>();
  const [openModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  const [state, setState] = useState<any>({
    pagination: {
      page: 1,
      perPage: 5,
    },
  });
  const { date, setDate, loading, data, deleteOpenningBalanceApi, handleDelete, handleChange, handleSubmit, handleAddRow, withoutMenu, withoutAddRow, count, openingBalance } =
    useOpeningBalanceData();

  const assetsSum = data.assets.map((x) => x.amount).reduce((x, i) => x + i, 0);
  const debtsSum = data.debts.map((x) => x.amount).reduce((x, i) => x + i, 0);
  const equitySum = data.equity.map((x) => x.amount).reduce((x, i) => x + i, 0);
  const salariesSum = assetsSum - debtsSum;

  const blocks: Block[] = [
    {
      data: data.assets,
      sum: assetsSum,
      title: {
        color: "#1E8E1B",
        icon: <BagIcon />,
        text: "دارایی ها",
      },
      expanded: true,
    },
    {
      data: data.debts,
      sum: debtsSum,
      title: {
        color: "#CB0B0B",
        icon: <DebtsIcon />,
        text: "بدهی ها",
      },
      expanded: false,
    },
    {
      data: data.equity,
      sum: equitySum,
      title: {
        color: "#1062D0",
        icon: <img src={PieChartIcon} alt="" />,
        text: "حقوق صاحبان سهام",
      },
      expanded: false,
    },
  ];

  function handleClick(item: BlockItem) {
    setActive(item.title);
    setOpenModal(true);
  }

  const item = data.assets
    .concat(data.debts)
    .concat(data.equity)
    .find((x) => x.title === active);

  function deleteOpeningBlance() {

    dispatch(setConfirm("حذف سند افتتاحیه", () => {
      deleteOpenningBalanceApi(true)

    }, undefined, "با تایید این عملیات تمام چک های سند حسابداری برای آن  صادر شده اند حذف میشود آیا مطمئن هستید؟", () => {
      // deleteOpenningBalanceApi(false)
    }));

  }

  return (
    <Container maxWidth="lg">
      <div>
        <div style={{ display: "flex", justifyContent: "space-between", margin: "20px 0px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <span style={{ fontSize: "18px", color: "#1a1919" }}>تراز افتتاحیه</span>
            <span style={{ fontSize: "10px", color: "#aeaeae" }}>نرم افزار حسابداری</span>
          </div>
          <div className="flex gap-3 place-items-center place-content-center">
            <BasicDateInput styles={{container:{width:202 ,marginBottom:30}}} defaultValues={[date]} label="تاریخ" onChange={(value) => {
              if (value)
                setDate(value[0])
            }} />
            <Button variant="contained" disabled={loading} onClick={handleSubmit}>
              ذخیره اطلاعات
            </Button>
            <Button variant="contained" className="bg-red-500 text-white " onClick={() => { deleteOpeningBlance() }}>
              <img src={iconDelete} alt="iconDelete" />
              <div>حذف</div>
            </Button>
          </div>
        </div>
        <SummaryComponent data={{ assetsSum, debtsSum, salariesSum: salariesSum }} />
        <Blocks blocks={blocks} onItemClick={handleClick} />
      </div>
      <Portal>
        <Modal disableScrollLock open={openModal}>
          <ModalBox
            title={item ? item.label : ""}
            onClose={() => {
              if (item?.validateOnClose) {
                item.validateOnClose(setOpenModal);
                return;
              }
              setOpenModal(false);
            }}
            footer={
              !withoutAddRow(active) ? (
                <BasicButton onClick={() => handleAddRow(active)} variant="outlined" className="mx-2">
                  <PlusIcon color="#1062D0" scale={0.6} />
                  <span color="#1062D0">افزودن ردیف</span>
                </BasicButton>
              ) : undefined
            }
          >
            {item && item.table && (
              <Table
                count={count}
                cols={item.table.cols}
                headers={item.table.headers}
                rows={item.data}
                onDelete={handleDelete}
                onChange={handleChange}
                withoutMenu={withoutMenu(active)}
                pagination={{
                  ...state.pagination,
                  onChange: ({ page, perPage }) =>
                    setState((x: any) => ({ ...x, pagination: { ...x.pagination, page, perPage } })),
                }}
              />
            )}
          </ModalBox>
        </Modal>
      </Portal>
    </Container>
  );
}
